import { z } from 'zod';
import { CapturedImageSchema, cognexLightModeSchema, cognexLightPowerOptionalSchema } from './efem-wafer-imaging.schemas.js';
const integerIdSchema = z.coerce.number().int().positive();
export const waferIdStationCaptureStrategySchema = z.enum([
    'full_auto',
    'single_mode_auto',
    'manual',
]);
export const waferIdStationAcquireRequestSchema = z
    .object({
    waferImagingTemplateId: integerIdSchema,
    captureStrategy: waferIdStationCaptureStrategySchema.default('full_auto'),
    /** Required when captureStrategy is single_mode_auto or manual */
    lightMode: cognexLightModeSchema.optional(),
    /** Required when captureStrategy is manual */
    startPower: z.number().int().min(0).max(127).optional(),
    cameraSerialOverride: z.string().min(1).max(255).optional(),
})
    .superRefine((data, ctx) => {
    if (data.captureStrategy !== 'full_auto' && data.lightMode == null) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'lightMode is required for single_mode_auto and manual capture',
            path: ['lightMode'],
        });
    }
    if (data.captureStrategy === 'manual' && data.startPower == null) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'startPower is required for manual capture',
            path: ['startPower'],
        });
    }
});
export const waferIdStationAcquireImageSchema = z.object({
    fileId: integerIdSchema,
    objectKey: z.string().min(1),
    previewUrl: z.string().url(),
    modeIndex: z.number().int(),
    imageIndex: z.number().int(),
    capturedAt: z.string(),
    lightMode: cognexLightModeSchema.optional(),
    startPower: cognexLightPowerOptionalSchema,
    finalPower: cognexLightPowerOptionalSchema,
    usedAutoAdjust: z.boolean().optional(),
});
export const waferIdStationAcquireResponseDataSchema = z.object({
    sessionId: z.string().min(1),
    cameraSerial: z.string().min(1),
    capturedImages: z.array(CapturedImageSchema),
    images: z.array(waferIdStationAcquireImageSchema),
});
export const waferIdStationAcquireResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    data: waferIdStationAcquireResponseDataSchema,
});
export const waferIdStationAcquireSaveRequestSchema = z.object({
    waferId: integerIdSchema,
    confirmedFingerprint: z.string().min(1).max(500),
    objectKeys: z.array(z.string().min(1)).min(1).max(10),
    attachAsFingerprint: z.boolean().default(true),
    ocrRaw: z.string().max(500).optional(),
    ocrConfidence: z.number().min(0).max(1).optional(),
});
export const waferIdStationAcquireSaveResponseDataSchema = z.object({
    waferId: integerIdSchema,
    linkedFileCount: z.number().int().min(0),
    fingerprint: z.string(),
});
export const waferIdStationAcquireSaveResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    data: waferIdStationAcquireSaveResponseDataSchema,
});
export const captureWaferImagesOptionsSchema = z.object({
    timeoutMs: z.number().int().positive().optional(),
    skipHardwareGuards: z.boolean().optional(),
    purpose: z.enum(['station_acquire']).optional(),
});
//# sourceMappingURL=wafer-id-station-acquire.schemas.js.map